var validNumber = function validNumber(_a) {
  var _b = _a === void 0 ? {
      message: 'Неверный формат числа'
    } : _a,
    message = _b.message;
  return function (number) {
    if (number === void 0) {
      number = NaN;
    }
    if (!isNaN(number) && isFinite(number)) {
      return;
    }
    return message;
  };
};
export default validNumber;
export { validNumber };